import Api from 'api';
import uuid from 'uuid';
import { getAssetDepreciation } from 'lib/assets/assets_helpers';

import {
  ADD_ASSET_NOTE,
  ADD_ASSET,
  ADD_ASSETS_FILES,
  CALCULATE_ASSET_DEPRECIATION,
  DISABLE_ASSET,
  GET_ASSET_BY_ID,
  GET_ASSETS_CSV,
  GET_ASSETS_XLSX,
  GET_ASSETS_DISABLE_FORM_CONFIG,
  GET_ASSETS_FORM_CONFIG,
  GET_ASSETS,
  MODIFY_ASSET_NOTE,
  MODIFY_ASSET,
  MODIFY_CUSTOM_FIELD_EDITING_ASSET, //Groups
  NEW_ASSET,
  ENABLE_ASSET,
  PROGRESS_ASSETS_FILE,
  REMOVE_ASSET_NOTE,
  REMOVE_ASSETS_FILE,
  REMOVE_ASSETS_UPLOADED_FILE,
  RESET_ASSETS_FORM,
  RESET_ASSETS_LIST,
  SET_ASSETS_FILTERS,
  SET_ASSETS_IS_SAVING,
  SET_ASSETS_PAGINATION,
  SET_ENABLE_ASSET_MODAL_IS_OPEN,
  SET_SELECTED_ASSET,
  UPDATE_ASSET,
  UPLOAD_ASSETS_FILE,
  GET_ASSET_HISTORICS,
  ACCEPT_ASSET_HISTORIC,
  REJECT_ASSET_HISTORIC,
  SET_ASSET_HISTORICS_PAGINATION,
  SET_ASSET_HISTORICS_FILTERS,
  RESET_ASSET_HISTORICS_LIST,
  MODIFY_FILE,
  SEND_TOKEN_ASIGN,
  OUTPUT_ASSET,
  INPUT_ASSET,
  ACEPT_OUTPUT,
  REJECT_OUTPUT,
  GET_CODE_LABELS_BY_ASSET_PDF,
  GET_QR_CODE_ASSET,
  REGENERATE_CODES_BY_ASSET_ID,
  DOWNLOAD_FILE_AND_CONVERT_TO_BASE64,
} from 'containers/assets/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const getAssetsFormConfig = (companyId, subcompanyId) => (dispatch) => {
  dispatch({
    type: GET_ASSETS_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.assets.getFormConfig(companyId, subcompanyId),
  }).then(
    ({
      value: {
        accounts,
        catalogs,
        costCenters,
        employees,
        locations,
        projects,
        providers,
        inpcs,
        depreciations,
        asset_levels,
      },
      action,
    }) => {
      dispatch({
        type: SET_LISTS,
        payload: {
          accounts,
          catalogs,
          costCenters,
          employees,
          locations,
          projects,
          providers,
          inpcs,
          depreciations,
          asset_levels,
        },
      });
    }
  );
};

export const modifyAsset = (payload) => ({ type: MODIFY_ASSET, payload });

export const addAsset = (companyId, subcompanyId, asset) => ({
  type: ADD_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.add(companyId, subcompanyId, asset),
});

export const getAssets = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_ASSETS,
  meta: { needAuth: true },
  payload: Api.assets.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const setPagination = (payload) => ({
  type: SET_ASSETS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_ASSETS_FILTERS,
  payload,
});

export const sendTokenAsign = (assetId, companyId, subcompanyId, asset) => ({
  type: SEND_TOKEN_ASIGN,
  meta: { needAuth: true },
  payload: Api.assets.sendTokenAsign(assetId, companyId, subcompanyId, asset),
});

export const newAsset = () => ({ type: NEW_ASSET });

export const getAsset = (assetId, companyId, subcompanyId) => ({
  type: GET_ASSET_BY_ID,
  payload: Api.assets.getById(assetId, companyId, subcompanyId),
});

export const updateAsset = (assetId, companyId, subcompanyId, asset) => ({
  type: UPDATE_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.update(assetId, companyId, subcompanyId, asset),
});

export const resetAssetsForm = () => ({ type: RESET_ASSETS_FORM });

export const resetAssetsList = () => ({ type: RESET_ASSETS_LIST });

export const calculateDepreciation = (date, asset, inpcs) => {
  return {
    type: CALCULATE_ASSET_DEPRECIATION,
    payload: {
      _financialDepreciationResult: asset._financialDepreciation
        ? getAssetDepreciation(asset, asset._financialDepreciation, false, inpcs, date)
        : null,
      _fiscalDepreciationResult: asset._fiscalDepreciation
        ? getAssetDepreciation(asset, asset._fiscalDepreciation, true, inpcs, date)
        : null,
      _extraDepreciationsResult: asset._extraDepreciations
        ? asset._extraDepreciations.map((depreciation) =>
            getAssetDepreciation(asset, depreciation, false, inpcs, date)
          )
        : [],
    },
  };
};

export const addAssetsFiles = (files) => {
  console.log('%c ' + files, 'background: #222; color: #bada55');

  files = files.map((f) => ({
    id: uuid.v4(),
    status: 'files.pending',
    percentage: 0,
    file: f,
    preview: f.preview,
    name: f.name,
  }));

  return {
    type: ADD_ASSETS_FILES,
    payload: files,
  };
};

export const removeAssetsFile = (id) => ({
  type: REMOVE_ASSETS_FILE,
  payload: id,
});

export const removeAssetsUploadedFile = (id) => ({
  type: REMOVE_ASSETS_UPLOADED_FILE,
  payload: id,
});

export const progressAssetsFile = (id, percentage) => ({
  type: PROGRESS_ASSETS_FILE,
  payload: { id, percentage },
});

export const uploadAssetsFile = (id, file, companyId, subcompanyId) => (dispatch) => {
  const onProgress = (percentage) => dispatch(progressAssetsFile(id, percentage));

  return dispatch({
    type: UPLOAD_ASSETS_FILE,
    meta: { id },
    payload: Api.uploads.upload(file, onProgress, companyId, subcompanyId),
  });
};

export const setAssetsIsSaving = (isSaving) => ({
  type: SET_ASSETS_IS_SAVING,
  payload: isSaving,
});

export const addAssetNote = ({ name, lastname, email }) => ({
  type: ADD_ASSET_NOTE,
  payload: {
    id: uuid.v4(),
    text: '',
    createdBy: { name, lastname, email },
  },
});

export const removeAssetNote = (id) => ({
  type: REMOVE_ASSET_NOTE,
  payload: id,
});

export const modifyAssetNote = (id, text) => ({
  type: MODIFY_ASSET_NOTE,
  payload: { id, text },
});

export const getAssetsCSV = (companyId, subcompanyId, filters) => ({
  type: GET_ASSETS_CSV,
  payload: Api.reports.getAssetsCSV(companyId, subcompanyId, filters),
});

/**
 * Get assets report in XLSX format for a company and subcompany with filters applied
 * @author Jorge Casas
 * 
 * @param {string} companyId - Company ID
 * @param {string} subcompanyId - Subcompany ID
 * @param {object} filters - Filters to apply to the report
 * @returns {Promise} - Promise object represents the XLSX file with the assets report
 */
export const getAssetsXLSX = (companyId, subcompanyId, filters) => ({
  type: GET_ASSETS_XLSX,
  payload: Api.reports.getAssetsXLSX(companyId, subcompanyId, filters),
});

export const getAssetsDisableFormConfig = (companyId, subcompanyId) => (dispatch) => {
  dispatch({
    type: GET_ASSETS_DISABLE_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.assets.getDisableFormConfig(companyId, subcompanyId),
  }).then(({ value: { catalogs, inpcs }, action }) => {
    dispatch({
      type: SET_LISTS,
      payload: {
        catalogs,
        inpcs,
      },
    });
  });
};

export const disableAsset = (assetId, companyId, subcompanyId, asset) => ({
  type: DISABLE_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.disable(assetId, companyId, subcompanyId, asset),
});

export const setSelectedAsset = (asset) => ({
  type: SET_SELECTED_ASSET,
  payload: asset,
});

export const setEnableAssetModalIsOpened = (isOpen) => ({
  type: SET_ENABLE_ASSET_MODAL_IS_OPEN,
  payload: isOpen,
});

export const enableAsset = (assetId, companyId, subcompanyId) => ({
  type: ENABLE_ASSET,
  payload: Api.assets.enable(assetId, companyId, subcompanyId),
});

export const getHistorics = (
  assetId,
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_ASSET_HISTORICS,
  meta: { needAuth: true },
  payload: Api.assets.getHistorics(
    assetId,
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const acceptHistoric = (historicId, assetId, companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: ACCEPT_ASSET_HISTORIC,
    meta: { needAuth: true, historicId },
    payload: Api.assets.acceptHistoric(historicId, assetId, companyId, subcompanyId),
  });

export const rejectHistoric = (historicId, assetId, companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: REJECT_ASSET_HISTORIC,
    meta: { needAuth: true, historicId },
    payload: Api.assets.rejectHistoric(historicId, assetId, companyId, subcompanyId),
  });

export const setHistoricsPagination = (payload) => ({
  type: SET_ASSET_HISTORICS_PAGINATION,
  payload,
});

export const setHistoricsFilters = (payload) => ({
  type: SET_ASSET_HISTORICS_FILTERS,
  payload,
});

export const resetHistoricsForm = () => ({ type: RESET_ASSET_HISTORICS_LIST });

export const requestUpdateAsset = (assetId, companyId, subcompanyId, asset) => ({
  type: UPDATE_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.requestUpdate(assetId, companyId, subcompanyId, asset),
});

export const requestOutputAsset = (assetId, companyId, subcompanyId, asset) => ({
  type: OUTPUT_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.outputAsset(assetId, companyId, subcompanyId, asset),
});
export const requestInputAsset = (assetId, companyId, subcompanyId, asset) => ({
  type: INPUT_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.inputAsset(assetId, companyId, subcompanyId, asset),
});
export const requestAceptOutput = (assetId, companyId, subcompanyId, asset) => ({
  type: ACEPT_OUTPUT,
  meta: { needAuth: true },
  payload: Api.assets.aceptOutput(assetId, companyId, subcompanyId, asset),
});
export const requestRejectOutput = (assetId, companyId, subcompanyId, asset) => ({
  type: REJECT_OUTPUT,
  meta: { needAuth: true },
  payload: Api.assets.rejectOutput(assetId, companyId, subcompanyId, asset),
});

export const modifyFile = (fileId, payload) => ({
  type: MODIFY_FILE,
  payload: { fileId, payload },
});

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_ASSET,
  payload,
}); // Agregado

export const putEditBill = async(assetId, companyId, subcompanyId, bill, files) => ({
  // type: REJECT_OUTPUT,
  // meta: { needAuth: true },
  payload: Api.assets.putBill(assetId, companyId, subcompanyId, bill, files),
});

/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 *  
 * @function putEditCustomsDocuments
 * 
 * @description Edit asset customs documents and upload files to the server for a specific asset, company and subcompany
 * 
 * @param {string} assetId - Asset ID
 * @param {string} companyId - Company ID
 * @param {string} subcompanyId - Subcompany ID
 * @param {object} customsDocuments - Customs documents data
 */
export const putEditCustomsDocuments = async(assetId, companyId, subcompanyId, customsDocuments, files) => ({
  payload: Api.assets.putCustomsDocuments(assetId, companyId, subcompanyId, customsDocuments, files),
});

/**
 * @author Jorge Casas
 * 
 * @creationDate 26/04/2024
 * 
 * @description Download a file and convert it to base64 format
 * 
 * @param {string} urlFile - File URL
 * @returns {Promise} - Promise object represents the file in base64 format
 * 
 * @version 3.4.16
 */
export const requestDownloadFileToConverBase64 = (urlFile) => ({
  type: DOWNLOAD_FILE_AND_CONVERT_TO_BASE64,
  payload: Api.assets.downloadFileToConverBase64(urlFile),
});

/**
 * @author Jorge Casas
 * @creationDate 01/07/2024
 * 
 * @description Get the codes labels by asset in PDF format for a company and subcompany
 * 
 * @param {string} companyId - Company ID
 * @param {string} subcompanyId - Subcompany ID
 * @param {object} filters - Filters to apply to the report
 * @returns {Promise} - Promise object represents the PDF file with the codes labels by asset
 */
export const getCodesLabelsByAssetPDFReport = (assetId, companyId, subcompanyId, filters) => ({
  type: GET_CODE_LABELS_BY_ASSET_PDF,
  meta: { needAuth: true },
  payload: Api.assets.getCodesLabelsByAssetPDF(assetId, companyId, subcompanyId, filters),
});

/**
 * @author Jorge Casas
 * 
 * @creationDate 23/07/2024
 * 
 * @description Get the QR code asset by asset ID
 * 
 * @param {string} assetId - Asset ID
 * @returns {Promise} - Promise object represents the QR code asset
 * 
 * @version 3.4.14
 * 
 */
export const getQRCodeAssetById = (assetId) => ({
  type: GET_QR_CODE_ASSET,
  meta: { needAuth: true },
  payload: Api.assets.getQRCode(assetId),
});

/**
 * @author Jorge Casas
 * 
 * @creationDate 23/07/2024
 * 
 * @description Regenerate the codes by asset ID
 * 
 * @param {string} assetId - Asset ID
 * @param {string} companyId - Company ID
 * @param {string} subcompanyId - Subcompany ID
 * @returns {Promise} - Promise object represents the regenerated codes
 * 
 * @version 3.4.14
 */
export const putRegenerateCodesByAssetId = (assetId, companyId, subcompanyId) => ({
  type: REGENERATE_CODES_BY_ASSET_ID,
  meta: { needAuth: true },
  payload: Api.assets.putRegenerateCodes(assetId, companyId, subcompanyId),
});


// WEBPACK FOOTER //
// src/containers/assets/actions.js